export default __webpack_public_path__ + "static/media/HTMLCircularBackground-light-sepia-350px.jpg.821d7555.webp";